// Class recipes shared by the Documents route's regions (locked comp
// `.impeccable/mocks/decision/documents.html` B). Presentational only.

/** Caps label for table heads, fact captions and group names (comp `.nm`, `.t th`, 10.5px 600). */
export const CAPS = 'text-[10px] font-semibold uppercase tracking-[0.07em] text-muted';

/** A document id or tag set as a code (comp `.idc`). */
export const DOC_ID = 'whitespace-nowrap font-mono text-[11px] text-muted';

/** A reference chip: a document, version or case named inline (comp `.ref`). */
export const REF =
  'inline-block whitespace-nowrap rounded-md border border-[var(--hairline-strong)] bg-[var(--surface-2)] px-1.5 font-mono text-[11px] leading-[1.35] text-ink-secondary';

/** The same chip in the breach tone: a stale or past-due sign-off (comp `.ref.bad`). */
export const REF_BAD =
  'inline-block whitespace-nowrap rounded-md border border-[color-mix(in_srgb,var(--state-blocked)_35%,transparent)] bg-[color-mix(in_srgb,var(--state-blocked)_9%,transparent)] px-1.5 font-mono text-[11px] leading-[1.35] text-[var(--state-blocked)]';

/**
 * `Draft — not live until approved`: the dashed neutral pill (comp `.p-draft`,
 * DESIGN.md § Semantic colour). Passed to `Pill` as its className; it
 * overrides the default pill's fill, case and tracking.
 */
export const DRAFT_PILL =
  'whitespace-nowrap border border-dashed border-[var(--hairline-strong)] bg-transparent px-2 py-px text-[11px] font-medium normal-case tracking-normal text-ink-secondary';

/** A fact row inside a card: key left, value right, hairline between rows (comp `.facts .f`). */
export const FACT_ROW =
  'grid grid-cols-[minmax(0,1fr)_auto] items-baseline gap-2.5 border-b border-[var(--color-divider)] py-1.5 text-[12.5px] last:border-b-0';

/** A fact caption opening a group of fact rows (comp `.facts .cap`). */
export const FACT_CAP = `${CAPS} border-b border-[var(--color-divider)] pb-1 pt-3`;

/** A prose block inside a fact list (comp `.facts .blk`). */
export const FACT_BLOCK =
  'border-b border-[var(--color-divider)] py-1.5 text-[12.5px] leading-[1.45] text-ink-secondary last:border-b-0';

/** `[syn]` as the comp draws it: a dashed neutral chip in the document header (comp `.syn`). */
export const SYN_MARK =
  'whitespace-nowrap rounded-full border border-dashed border-[var(--hairline-strong)] px-[7px] py-px font-mono text-[10px] text-muted';
